import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.history');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-history',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.history/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.hn-history-page {
  max-width: 1280px;
}

.hn-history-refresh {
  align-items: center;
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 9px;
  color: var(--hn-ink);
  display: inline-flex;
  font-size: 14px;
  font-weight: 800;
  gap: 8px;
  min-height: 40px;
  padding: 0 12px;
}

.hn-history-refresh:disabled {
  color: var(--hn-muted);
}

.hn-history-feedback {
  align-items: center;
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: 12px;
  display: flex;
  gap: 10px;
  margin-top: 12px;
  min-height: 54px;
  padding: 11px 14px;
}

.hn-history-feedback > span {
  animation: hn-history-pulse 0.8s ease-in-out infinite alternate;
  background: var(--hn-accent);
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.hn-history-feedback.is-error {
  justify-content: space-between;
}

.hn-history-feedback.is-error strong {
  color: var(--hn-danger);
  display: block;
}

.hn-history-feedback.is-error p {
  color: var(--hn-muted);
  font-size: 14px;
  margin: 4px 0 0;
}

.hn-history-feedback button {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 9px;
  font-size: 14px;
  font-weight: 700;
  min-height: 44px;
  padding: 0 14px;
}

@keyframes hn-history-pulse {
  to {
    opacity: 0.3;
    transform: scale(0.78);
  }
}
.hn-history-tabs {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: 11px;
  display: inline-flex;
  gap: 3px;
  margin-top: 10px;
  padding: 3px;
}

.hn-history-tabs button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 7px;
  color: var(--hn-muted-strong);
  display: inline-flex;
  font-size: 14px;
  font-weight: 800;
  gap: 7px;
  min-height: 40px;
  padding: 0 13px;
}

.hn-history-tabs button.is-active {
  background: var(--hn-charcoal);
  color: #fff;
}

.hn-history-tabs button i {
  color: var(--hn-accent-deep);
}

.hn-history-tabs button.is-active i {
  color: var(--hn-accent);
}

.hn-history-tabs em {
  background: var(--hn-paper-muted);
  border-radius: 999px;
  color: var(--hn-muted);
  font-size: 14px;
  font-style: normal;
  min-width: 24px;
  padding: 3px 6px;
  text-align: center;
}

.hn-history-tabs button.is-active em {
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.82);
}

.hn-section-title {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 11px;
  padding: 0 2px;
}

.hn-section-title h2 {
  font-size: 18px;
  margin: 0;
}

.hn-section-title p {
  color: var(--hn-muted);
  font-size: 14px;
  line-height: 1.5;
  margin: 5px 0 0;
}

.hn-section-title > span {
  color: var(--hn-muted);
  font-size: 14px;
  font-weight: 700;
}

.hn-cycle-section,
.hn-daily-history {
  margin-top: 12px;
}

.is-positive {
  color: var(--hn-danger) !important;
}

.is-negative {
  color: #3471b8 !important;
}

.hn-analysis-notice {
  align-items: center;
  background: #eef4ff;
  border: 1px solid #cfddf5;
  border-radius: 11px;
  display: flex;
  gap: 10px;
  margin-top: 12px;
  padding: 10px 13px;
}

.hn-analysis-notice > i {
  color: #3c69a9;
  margin-top: 2px;
}

.hn-analysis-notice strong {
  display: block;
  font-size: 14px;
}

.hn-analysis-notice p {
  color: #53677f;
  font-size: 13px;
  line-height: 1.45;
  margin: 2px 0 0;
}

.hn-daily-history__scroll {
  display: grid;
  gap: 10px;
  grid-auto-columns: minmax(280px, 1fr);
  grid-auto-flow: column;
  overflow-x: auto;
  padding: 2px 2px 7px;
  scroll-snap-type: x proximity;
}

.hn-daily-history__scroll:focus-visible {
  outline: 3px solid #2359cb;
  outline-offset: 3px;
}

.hn-daily-history article {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: 13px;
  min-width: 0;
  padding: 14px;
  scroll-snap-align: start;
}

.hn-daily-history article.is-alert {
  border-color: #e6c98f;
}

.hn-daily-history__date {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.hn-daily-history__date strong {
  font-size: 15px;
}

.hn-daily-history__date span {
  background: var(--hn-accent-soft);
  border-radius: 7px;
  color: var(--hn-accent-deep);
  font-size: 14px;
  font-weight: 800;
  padding: 6px 8px;
}

.hn-daily-history article.is-alert .hn-daily-history__date span {
  background: #fff4e5;
  color: #8c570d;
}

.hn-daily-history dl {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin: 12px 0 0;
}

.hn-daily-history dt {
  color: var(--hn-muted);
  font-size: 14px;
}

.hn-daily-history dd {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  margin: 5px 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.hn-daily-history article > p {
  border-top: 1px solid var(--hn-line);
  color: var(--hn-muted-strong);
  font-size: 14px;
  line-height: 1.45;
  margin: 14px 0 0;
  padding-top: 11px;
}

.hn-daily-history ul {
  color: #805510;
  font-size: 14px;
  line-height: 1.5;
  margin: 9px 0 0;
  padding-left: 18px;
}

.hn-history-panel {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: var(--hn-radius-lg);
  margin-top: 12px;
  overflow: hidden;
}

.hn-panel-head {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: flex;
  justify-content: space-between;
  min-height: 56px;
  padding: 10px 16px;
}

.hn-panel-head h2 {
  font-size: 18px;
  margin: 0;
}

.hn-panel-head p {
  color: var(--hn-muted);
  font-size: 14px;
  margin: 5px 0 0;
}

.hn-panel-head > span {
  background: var(--hn-accent-soft);
  border-radius: 7px;
  color: var(--hn-accent-deep);
  font-size: 14px;
  font-weight: 800;
  padding: 7px 9px;
}

.hn-history-empty {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 150px;
  padding: 22px 18px;
  text-align: center;
}

.hn-history-empty__icon {
  align-items: center;
  background: var(--hn-accent-soft);
  border: 1px solid #d9e8bd;
  border-radius: 14px;
  color: var(--hn-accent-deep);
  display: flex;
  font-size: 18px;
  height: 48px;
  justify-content: center;
  margin-bottom: 15px;
  width: 48px;
}

.hn-history-empty > strong {
  font-size: 16px;
}

.hn-history-empty > p {
  color: var(--hn-muted);
  font-size: 14px;
  line-height: 1.6;
  margin: 8px 0 0;
}

.hn-event-list {
  padding: 0 16px;
}

.hn-event-row {
  align-items: center;
  border-bottom: 1px solid var(--hn-line);
  display: grid;
  gap: 13px;
  grid-template-columns: 120px 48px minmax(160px, 1fr) 130px 60px;
  min-height: 64px;
}

.hn-event-row:last-child {
  border-bottom: 0;
}

.hn-event-time strong, .hn-event-time small, .hn-event-name strong, .hn-event-name small, .hn-event-value strong, .hn-event-value small {
  display: block;
}

.hn-event-time strong {
  font-size: 14px;
  font-variant-numeric: tabular-nums;
}

.hn-event-time small, .hn-event-name small, .hn-event-value small {
  color: var(--hn-muted);
  font-size: 14px;
  margin-top: 4px;
}

.hn-event-side {
  align-items: center;
  border-radius: 7px;
  display: inline-flex;
  font-size: 14px;
  font-weight: 800;
  justify-content: center;
  min-height: 30px;
}

.hn-event-side.is-buy {
  background: #fff0ee;
  color: #bd443a;
}

.hn-event-side.is-sell {
  background: #edf4fd;
  color: #376fae;
}

.hn-event-side.is-cycle {
  background: var(--hn-accent-soft);
  color: var(--hn-accent-deep);
}

.hn-event-name strong, .hn-event-value strong {
  font-size: 14px;
}

.hn-event-value {
  text-align: right;
}

.hn-event-status {
  background: var(--hn-paper-muted);
  border-radius: 7px;
  color: var(--hn-muted-strong);
  font-size: 14px;
  font-weight: 700;
  padding: 7px 8px;
  text-align: center;
}

.hn-event-status.is-filled {
  background: var(--hn-accent-soft);
  color: var(--hn-accent-deep);
}

.hn-load-more {
  display: flex;
  justify-content: center;
  padding: 14px 0 2px;
}

.hn-load-more button {
  align-items: center;
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 10px;
  display: inline-flex;
  font-size: 14px;
  font-weight: 800;
  gap: 8px;
  min-height: 46px;
  padding: 0 18px;
}

@media (max-width: 820px) {
  .hn-event-list {
    padding: 0 17px;
  }
  .hn-event-row {
    gap: 10px 12px;
    grid-template-columns: 46px minmax(0, 1fr) auto;
    padding: 15px 0;
  }
  .hn-event-time {
    grid-column: 2/4;
    grid-row: 1;
  }
  .hn-event-side {
    grid-column: 1;
    grid-row: 2;
  }
  .hn-event-name {
    grid-column: 2;
    grid-row: 2;
  }
  .hn-event-value {
    grid-column: 3;
    grid-row: 2;
  }
  .hn-event-status {
    display: inline-flex;
    grid-column: 2/4;
    grid-row: 3;
    justify-self: start;
  }
}
@media (max-width: 620px) {
  .hn-history-refresh span {
    display: none;
  }
  .hn-history-refresh {
    justify-content: center;
    padding: 0;
    width: 44px;
  }
  .hn-history-tabs {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 100%;
  }
  .hn-history-tabs button {
    justify-content: center;
    padding: 0 10px;
  }
  .hn-section-title {
    gap: 12px;
  }
  .hn-section-title > span {
    white-space: nowrap;
  }
  .hn-daily-history dl {
    grid-template-columns: 1fr 1fr;
  }
  .hn-daily-history dl div:last-child {
    grid-column: 1/-1;
  }
  .hn-panel-head {
    align-items: flex-start;
    gap: 12px;
    padding: 16px 17px;
  }
  .hn-event-value strong {
    white-space: nowrap;
  }
  .hn-history-feedback.is-error {
    align-items: stretch;
    flex-direction: column;
  }
}`],
})
export class PageHistoryComponent implements OnInit {
    public mode = 'live';
    public liveItems: any[] = [];
    public analysisItems: any[] = [];
    public cycles: any[] = [];
    public dailyReports: any[] = [];
    public analysisHasMore = false;
    public loading = true;
    public refreshing = false;
    public loadingMore = false;
    public loadError = '';

    private readonly pageSize = 30;
    private analysisOffset = 0;

    constructor(@Inject( Service) public service: Service) { }

    public get hasMore() {
        return this.mode === 'analysis' && this.analysisHasMore;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async setMode(mode: string) {
        if (mode !== 'live' && mode !== 'analysis') return;
        this.mode = mode;
        await this.service.render();
    }

    public async load(refresh = false) {
        if (refresh) this.refreshing = true;
        else this.loading = true;
        this.loadError = '';
        await this.service.render();

        try {
            const { code, data } = await wiz.call('get', {
                scope: 'all',
                limit: this.pageSize,
                live_offset: 0,
                analysis_offset: 0
            });
            if (code !== 200 || !data) {
                throw new Error((data && data.message) || '잠시 후 다시 시도해주세요.');
            }
            const livePage = data.live_items || [];
            const analysisPage = data.analysis_items || [];
            this.liveItems = this.liveOnly(livePage);
            this.analysisItems = this.analysisOnly(analysisPage);
            this.analysisOffset = analysisPage.length;
            this.cycles = data.live_cycles || [];
            this.dailyReports = data.daily_reports || [];
            this.analysisHasMore = !!data.analysis_has_more;
        } catch (error: any) {
            this.loadError = error?.message || '잠시 후 다시 시도해주세요.';
        } finally {
            this.loading = false;
            this.refreshing = false;
            await this.service.render();
        }
    }

    public async loadMore() {
        if (this.loadingMore || !this.hasMore) return;
        if (this.mode !== 'analysis') return;
        this.loadingMore = true;
        await this.service.render();
        try {
            const query: any = {
                scope: 'analysis', limit: this.pageSize,
                analysis_offset: this.analysisOffset
            };
            const { code, data } = await wiz.call('get', query);
            if (code !== 200 || !data) {
                throw new Error((data && data.message) || '기록을 더 불러오지 못했습니다.');
            }
            const incoming = data.analysis_items || [];
            this.analysisOffset += incoming.length;
            this.analysisItems = this.unique(this.analysisItems, this.analysisOnly(incoming));
            this.analysisHasMore = incoming.length > 0 && !!data.analysis_has_more;
        } catch (error: any) {
            await this.service.modal.error(error?.message || '기록을 더 불러오지 못했습니다.');
        } finally {
            this.loadingMore = false;
            await this.service.render();
        }
    }

    private liveOnly(items: any[]) {
        return items.filter((item: any) => (
            item?.execution_mode === 'LIVE'
            && (item?.kind === 'LIVE_FILL' || item?.kind === 'CYCLE_COMPLETE')
        ));
    }

    private analysisOnly(items: any[]) {
        return items.filter((item: any) => (
            item?.execution_mode === 'SHADOW'
            && item?.kind === 'STRATEGY_SIGNAL'
        ));
    }

    private unique(current: any[], incoming: any[]) {
        const keys = new Set(current.map((item: any) => this.itemKey(item)));
        return current.concat(incoming.filter((item: any) => {
            const key = this.itemKey(item);
            if (keys.has(key)) return false;
            keys.add(key);
            return true;
        }));
    }

    private itemKey(item: any) {
        return [item.execution_mode, item.kind, item.id].join(':');
    }

    public itemType(item: any) {
        return '전략 조건';
    }

    public itemLabel(item: any) {
        const role = String(item?.intent || '');
        const addSell = role.match(/^ADD_SELL_(\d+)_(\d+)$/);
        if (addSell) return `추가 ${addSell[1]}차 물량 ${addSell[2]}차 매도`;
        const numbered: Array<[RegExp, string]> = [
            [/^ADD_BUY_(\d+)$/, '차 추가 매수'],
            [/^REBUY_(\d+)$/, '차 재매수'],
            [/^RECYCLE_SELL_(\d+)$/, '차 재매수분 매도'],
            [/^PARTIAL_SELL_(\d+)$/, '차 분할 매도'],
            [/^EXIT_(\d+)$/, '차 분할 매도']
        ];
        for (const [pattern, suffix] of numbered) {
            const match = role.match(pattern);
            if (match) return match[1] + suffix;
        }
        const labels: any = {
            INITIAL_BUY: '첫 매수',
            FINAL_SELL: '마지막 매도',
            RECYCLE_SELL: '재매수분 매도'
        };
        return labels[role] || (item?.side === 'BUY' ? '매수 조건' : '매도 조건');
    }

    public sideLabel(item: any) {
        return item?.side === 'BUY' ? '매수' : '매도';
    }

    public statusLabel(item: any) {
        const labels: any = {
            FILLED: '체결', EXECUTED: '처리', COMPLETED: '완료',
            PENDING: '대기', SKIPPED: '미실행', CANCELLED: '취소',
            REJECTED: '제외'
        };
        return labels[item?.status] || '확인';
    }

    public reasonLabel(code: string) {
        const labels: any = {
            DATA_INCOMPLETE: '1분봉 데이터 부족',
            RISK_BLOCKED: '안전 조건으로 실행하지 않음',
            NO_RULE_MATCH: '전략 조건 불충족',
            POSITION_CLOSED: '보유 수량 정리 완료',
            SIGNAL_EMITTED: '전략 조건 감지'
        };
        return labels[String(code || '')] || '전략 판단 기록';
    }

    public warningLabel(code: string) {
        const labels: any = {
            DATA_INCOMPLETE: '1분봉 일부 누락',
            RISK_BLOCKED: '안전 조건 확인 필요',
            MARKET_CALENDAR_UNKNOWN: '거래 일정 확인 필요',
            PARTIAL: '집계 미완료'
        };
        return labels[String(code || '')] || '상세 확인 필요';
    }

    public reportState(report: any) {
        if (report?.status === 'FINAL') return '확정';
        if (report?.status === 'PARTIAL') return '확인 필요';
        return '집계 중';
    }

    public reportReason(report: any) {
        const labels: any = {
            DATA_INCOMPLETE: '1분봉 데이터가 부족했습니다.',
            RISK_BLOCKED: '안전 조건으로 계산상 주문을 만들지 않았습니다.',
            NO_RULE_MATCH: '매매 조건에 해당하지 않았습니다.'
        };
        return labels[report?.no_trade_reason] || '분석을 완료했습니다.';
    }

    public formatNumber(value: any) {
        return Number(value || 0).toLocaleString('ko-KR');
    }

    public formatPrice(value: any) {
        const price = Number(value || 0);
        return price > 0 ? price.toLocaleString('ko-KR') + '원' : '-';
    }

    public formatPnl(value: any) {
        const pnl = Number(value || 0);
        return (pnl > 0 ? '+' : '') + pnl.toLocaleString('ko-KR') + '원';
    }

    public formatDate(value: any) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return '-';
        return new Intl.DateTimeFormat('ko-KR', {
            timeZone: 'Asia/Seoul',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }

}

export default PageHistoryComponent;